import { useRoles } from "@/hooks/useRoles";
import { Loading } from "@/components/Page/Loading";
import { Forbidden } from "@/components/Page/Forbidden";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { ShopsTable } from "@/components/Shops/Shops.table";
import { CreateShopDialog } from "@/components/Shops/CreateShop.dialog";

const ShopsPage = () => {
  const { isSuperAdmin, isAdmin, isInitialized } = useRoles();
  useIsSuperAdmin();

  if (!isInitialized) return <Loading />;
  if (isInitialized && !(isSuperAdmin || isAdmin)) return <Forbidden />;

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex flex-row items-center justify-between gap-2">
        <h1 className="text-2xl">Shops</h1>
        {isSuperAdmin && <CreateShopDialog />}
      </div>
      <div className="overflow-auto">
        <ShopsTable />
      </div>
    </div>
  );
};

export default ShopsPage;
